module.exports = __webpack_public_path__ + "img/pantalla2.158ee7a1.jpg";